import { render, staticRenderFns } from "./MateriaSelect.vue?vue&type=template&id=11389b3e"
import script from "./MateriaSelect.vue?vue&type=script&lang=js"
export * from "./MateriaSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports